module.exports = require("./UtilityWidgetItem.vue");